var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
import axiosRetry, { exponentialDelay, isNetworkOrIdempotentRequestError, } from 'axios-retry';
// By default we enable a number of 5 retries using an exponential back-off
export const DEFAULT_RETRY_CONFIG = {
    retries: 5,
    retryCondition: (error) => { var _a; return isNetworkOrIdempotentRequestError(error) || ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 429; },
    retryDelay: exponentialDelay,
};
export class ApiClient {
    /**
     * constructor
     * @param baseUrl URL prefix for API requests.
     */
    constructor(options) {
        /**
         * Instance of the HTTP client.
         */
        Object.defineProperty(this, "httpClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        const { retry } = options, axiosConfig = __rest(options, ["retry"]);
        this.httpClient = axios.create(axiosConfig);
        const retryConfig = retry !== null && retry !== void 0 ? retry : {};
        if (retryConfig) {
            // @ts-ignore
            axiosRetry(this.httpClient, Object.assign(Object.assign({}, DEFAULT_RETRY_CONFIG), retryConfig));
        }
    }
    /**
     * Submit a request
     * @param endpoint
     * @param options
     */
    request(endpoint, options) {
        return this.httpClient(endpoint, options).then(({ data }) => data);
    }
}
//# sourceMappingURL=ApiClient.js.map